// External links of the league: social media and sponsors
export const SOCIAL_LINKS = {
    facebook: 'https://www.facebook.com/commercial.league.gr',
    instagram: 'https://www.instagram.com/commercial_league.gr/',
    youtube: 'https://www.youtube.com/channel/UC5hvrVJnTvrSrcf970QpqNg',
    twitter: 'https://x.com/Comm_league',
    linkedin: 'https://www.linkedin.com/company/commercial-league/',
    gsa: 'https://www.gsasport.com/gr/',
    'e-academy': 'https://eacademy.gr/',
    ioli: 'https://www.iolispring.gr/'
}

export function openSocial(social) {
    const link = SOCIAL_LINKS[social]
    if (link) {
        window.open(link, '_blank')
    }
}

// the sponsors shown on the home page and in the footer
export const SPONSORS = [
    { key: 'gsa', label: 'Official Appearance', image: require('@/assets/gsa.jpg') },
    { key: 'molten', label: 'Official Ball', image: require('@/assets/molten.png') },
    { key: 'e-academy', label: 'Official Sponsor', image: require('@/assets/e-academy.png') },
    { key: 'ioli', label: 'Official Water Sponsor', image: require('@/assets/IOLI_logo GR.jpg') },
    { key: 'sportsiq', label: 'Powered by', image: require('@/assets/sportsiq.jpg') }
]
